var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 41,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 41,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4102 27.6673C23.4102 26.4919 24.363 25.5391 25.5384 25.5391H55.3332C56.5086 25.5391 57.4614 26.4919 57.4614 27.6673V57.4621C57.4614 58.6375 56.5086 59.5903 55.3332 59.5903H25.5384C24.363 59.5903 23.4102 58.6375 23.4102 57.4621V27.6673ZM31.923 27.6673V40.4365H48.9486V27.6673H31.923ZM48.9486 44.6929H31.923V57.4621H48.9486V44.6929ZM25.5384 27.6673V31.9237H29.7948V27.6673H25.5384ZM29.7948 34.0519H25.5384V38.3083H29.7948V34.0519ZM25.5384 40.4365V44.6929H29.7948V40.4365H25.5384ZM29.7948 46.8211H25.5384V51.0775H29.7948V46.8211ZM25.5384 53.2057V57.4621H29.7948V53.2057H25.5384ZM55.3332 27.6673H51.0768V31.9237H55.3332V27.6673ZM51.0768 34.0519V38.3083H55.3332V34.0519H51.0768ZM55.3332 40.4365H51.0768V44.6929H55.3332V40.4365ZM51.0768 46.8211V51.0775H55.3332V46.8211H51.0768ZM55.3332 53.2057H51.0768V57.4621H55.3332V53.2057Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelIcon);
export default __webpack_public_path__ + "static/media/channel-icon.06abbc26e412809f50fcebc5812d4df3.svg";
export { ForwardRef as ReactComponent };